export default "__VITE_ASSET__B_ayK88l__"